// const API_URL = "http://localhost:8000/api";
// const API_URL = "https://dev.amantradingcompany.in/api";
const API_URL = "https://atc-backend.onrender.com/api";

module.exports = API_URL;

